import { IdentityCard, CardBand } from '@cb/apricot-react';

const Introduction = () => {
    const appId = "42";
    const redirectUrl =  'https://' + window.location.hostname + ':'+ window.location.port ;

    return (
        <CardBand
            title="College Board"
            description={<><b> Code Request Portal</b> : <br/>
                The College Board Code Request Portal is an administrative tool used to review, manage 
                and process requests to add and update College Board School and Score Send Codes.</>}
            className="cb-blue5-bg cb-white-color"
            tintClass="cb-tint-blue5-1">
            <IdentityCard
                className="cb-black1-color"
                id="identityCardComponent"
                appId={appId}
                destinationUrl={redirectUrl}
                loginUrl="https://account.collegeboard.org/login/login"
                createAccountUrl="https://account.collegeboard.org/login/signUp"
                isStudent={false}
            />
        </CardBand>
    );
};

export default Introduction;
